import { CSS } from "@react-spring/web";

import { HorizontalTab, TabProps } from "ui/core/horizontal-tab";

import { Select } from "./Select";

type Props = {
  tabs: TabProps[];
  activeKey: string;
  onChange: (key: string) => void;
};

export const ResponsiveTab = ({ tabs, activeKey, onChange }: Props) => (
  <>
    <div className="hidden @3xl:block">
      <div className="whitespace-nowrap border-b border-gray-200">
        <nav
          style={
            {
              "--tabs-length": tabs.length,
            } as CSS.Properties
          }
          className="-mb-px space-x-6"
        >
          <HorizontalTab
            tabs={tabs}
            activeKey={activeKey}
            onTabClick={onChange}
          />
        </nav>
      </div>
    </div>
    <Select tabs={tabs} onChange={onChange} activeKey={activeKey} />
  </>
);
